import React from 'react';
import PropTypes from 'prop-types';
import { titleCase, numberWithCommas } from '../../../../utils/formatting';
import { useStatsig } from '../../../hooks/useStatsig';

import styles from '../newStatsTabContent.scss';

const buildCardTitle = (rank, type, gender) => {
    const { rankingCategories } = rank;
    const location = rankingCategories.find(el => el.type === 'location');
    const tag = rankingCategories.find(el => el.type === 'tag');
    const genderSuffix = gender ? ` (${gender})` : '';

    if (type === 'ptt') {
        return `Pro Tennis Tour (PTT) Rank${genderSuffix}`;
    }

    const locationPart = location?.value ? ` ${titleCase(location.label)}` : '';
    const tagPart = tag?.value ? ` ${titleCase(tag.label)}` : '';
    const suffix = (locationPart || tagPart) ? ` -${locationPart}${tagPart}` : '';

    return `Verified Ranking${genderSuffix}${suffix}`;
};

function RankingsV2({ rankingCards }) {
    const { checkGate, featureGates } = useStatsig();
    const isLocalizedRankingsEnabled = checkGate(featureGates.LOCALIZED_RANKINGS);

    const filteredCards = isLocalizedRankingsEnabled
        ? rankingCards.filter(card => {
            if (card.type === 'ptt') { return true; }
            const tags = card.rankingCategories.filter(c => c.type === 'tag');
            return tags.every(tag => tag.value !== null);
        })
        : rankingCards;

    if (!filteredCards || filteredCards.length === 0) {
        return (
            <React.Fragment>
                <div className={styles.rankingsV2Header}>
                    Rankings
                </div>
                <div className={styles.rankingsV2EmptyState}>
                    No rankings available
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className={styles.rankingsV2Header}>
                Rankings
            </div>
            <div className={styles.rankingsV2Row}>
                {filteredCards.map(card => (
                    <div key={card.rankListId} className={styles.rankingsV2ColWrapper}>
                        <div className={styles.rankingCard}>
                            <div className={styles.rankingCardHeader}>
                                {buildCardTitle(card, card.type, card.gender)}
                            </div>
                            <div className={styles.rankingCardBody}>
                                <span className={styles.rankingCardNumber}>
                                    {numberWithCommas(card.rank)}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
}
RankingsV2.propTypes = {
    rankingCards: PropTypes.arrayOf(PropTypes.shape({
        rankListId: PropTypes.number,
        rank: PropTypes.number,
        type: PropTypes.string,
        gender: PropTypes.string,
        rankingCategories: PropTypes.arrayOf(PropTypes.shape({
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
        })),
    })),
};

RankingsV2.defaultProps = {
    rankingCards: [],
};

export default RankingsV2;
